/**
 * @voltxampere/engine — ERC rule: floating-node (Sprint 56)
 *
 * A net wired to a single terminal (orphan node). Topologically the
 * MNA matrix can still solve (gmin keeps it well-conditioned), but
 * the result has no physical meaning — the user almost certainly
 * forgot a wire.
 *
 * Ground nets are EXEMPT because they're implicit reference points;
 * having a single ground component connected to GND is valid by design.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
export const floatingNodeRule = {
    id: "floating-node",
    defaultSeverity: "warn",
    requiresDCResult: false,
    check(circuit) {
        const violations = [];
        // Count terminals per net.
        const counts = new Map();
        for (const c of circuit.components) {
            for (const t of c.terminals) {
                counts.set(t.netId, (counts.get(t.netId) ?? 0) + 1);
            }
        }
        for (const net of circuit.nets) {
            if (net.isGround)
                continue;
            const count = counts.get(net.id) ?? 0;
            if (count <= 1) {
                violations.push({
                    ruleId: "floating-node",
                    severity: "warn",
                    i18nKey: "erc.floating-node.message",
                    suggestionKey: "erc.floating-node.suggestion",
                    meta: {
                        netId: net.id,
                        netName: net.name,
                        terminalCount: count,
                    },
                });
            }
        }
        return violations;
    },
};
//# sourceMappingURL=floating-node.js.map